// extracted by mini-css-extract-plugin
export default {"lds-ellipsis":"Loader_lds-ellipsis__bE0+C","lds-ellipsis1":"Loader_lds-ellipsis1__9lFMY","lds-ellipsis2":"Loader_lds-ellipsis2__yY30J","lds-ellipsis3":"Loader_lds-ellipsis3__hpweN"};